module.exports = __webpack_public_path__ + "static/media/iconVaerelset.8db88544.png";